import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes = [
    // 首页
    {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/Home.vue')
    },
    {
        // 列表页, 含文章栏目，专题列表，H5列表
        path: '/list/:type/:id?/:skId?',
        component: () => import('@/pages/List.vue')
    },
    {
        // 新闻详情页，含视频新闻
        path: '/news/:id',
        name: 'News',
        component: () => import('@/pages/News.vue')
    },
    {
        // 搜索结果页
        path: '/search',
        name: 'Search',
        component: () => import('@/pages/Search.vue')
    },
    // {
    //     // 专题列表
    //     path: '/subjectList',
    //     name: 'SubjectList',
    //     component: () => import('@/pages/SubjectList.vue')
    // },
    {
        // 专题详情
        path: '/subject/:id',
        name: 'SubjectDetail',
        component: () => import('@/pages/SubjectDetail.vue')
    },
    {
        // 这个一定要放在所有的路由后面
        path: '*',
        redirect: '/'
    }
]


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'hash',
    // base: process.env.NODE_ENV === 'production' ? 'todo' : '/'
    routes
})

export default router